namespace Matrix.Administration {
    export class PermissionSetColumns {
        static columnsKey = 'Administration.PermissionSet';
    }
}
